export default {
  SET_PAGINATION(state, data) {
    state.pagination = data
  },
  SET_PAYABLES(state, documents) {
    state.payables = documents
  },
  SET_EINVOICES(state, documents) {
    state.einvoices = documents
  },
  SET_EINVOICES_FAILED_CASES(state, documents) {
    state.eInvoiceFailedCases = documents
  },
  SET_EINVOICES_EMAIL_COUNT(state, documents) {
    state.einvoicesEmailCount = documents
  },
  UPDATE_EINVOICES(state, document) {
    const certIndex = state.einvoices.findIndex((e) => e.id === document.id)
    Object.assign(state.einvoices[certIndex], document)
  },
  DELETE_INVOICE(state, itemId) {
    const certIndex = state.invoices.findIndex((u) => u.id === itemId)
    state.invoices.splice(certIndex, 1)
  },
  SET_PRO_FORMA_INVOICES(state, data) {
    state.proFormaInvoices = data
  },
  DELETE_PRO_FORMA_INVOICE(state, itemId) {
    const certIndex = state.proFormaInvoices.findIndex((u) => u.id === itemId)
    state.proFormaInvoices.splice(certIndex, 1)
  },
  SET_CN_DNS(state, data) {
    state.cnDns = data
  },
  DELETE_CN_DN(state, itemId) {
    const certIndex = state.cnDns.findIndex((u) => u.id === itemId)
    state.cnDns.splice(certIndex, 1)
  },
  // SET_DOCUMENT(state, document) {
  //   state.document = document;
  // },
  // ADD_DOCUMENT(state, document) {
  //   state.documents.push(document);
  // },
  // UPDATE_DOCUMENT(state, document) {
  //   const certIndex = state.documents.findIndex(
  //     e => e.id === document.id
  //   );
  //   Object.assign(state.documents[certIndex], document);
  // },
  DELETE_DOCUMENT(state, itemId) {
    const certIndex = state.documents.findIndex((u) => u.id === itemId)
    state.documents.splice(certIndex, 1)
  },
  SET_COLLECTION_DASHBOARD(state, collection) {
    state.collection = collection
  },
  SET_DASHBOARD_EINVOICE_COUNT(state, eInvoiceCount) {
    state.eInvoiceCount = eInvoiceCount
  },
  SET_TRANSACTION_REPORT(state, transactionReport) {
    state.transactionReport = transactionReport
  },
  SET_DASHBOARD_SUMMARY(state, summary) {
    state.summary = summary
  },
  DELETE_PF(state, itemId) {
    const certIndex = state.proFormaInvoices.findIndex((u) => u.id === itemId)
    state.proFormaInvoices.splice(certIndex, 1)
  },
}
